import React from "react";

import PopoverOverlay from "components/UI/_TODO/PopoverOverlay/PopoverOverlay";

import { Switch } from "shared/ui/inputs/Switch/Switch";

import styles from "./TableReusableColumnSet.module.scss";

interface TableReusableColumnSetProps {
  columns: Array<{ header: { title: string }; hidden?: boolean }>;
  toggleColHidden: (colTitle: string) => void;
}

const TableReusableColumnSet: React.FC<TableReusableColumnSetProps> = ({ columns, toggleColHidden }) => {
  if (!columns.length) return null;
  const hasHidden = columns.some((c) => c.hidden);
  return (
    <div className={styles.wrapper}>
      <PopoverOverlay
        openType="click"
        placement="bottom-end"
        content={
          <div className={styles.popoverContent}>
            <span className={styles.heading}>Настройки отображения</span>
            <div className={styles.list}>
              {columns.map((col) => (
                <Switch
                  className={styles.switch}
                  key={col.header.title}
                  label={col.header.title}
                  checked={!col.hidden}
                  onChange={() => toggleColHidden(col.header.title)}
                />
              ))}
            </div>
          </div>
        }
      >
        <div>
          <div className={styles.icon} />
          {hasHidden && <div className={styles.indicator} />}
        </div>
      </PopoverOverlay>
    </div>
  );
};

export default React.memo(TableReusableColumnSet);
